@if(showBackButton)
{
  <button matButton="outlined"
    class="inline mb-2"
    style="background-color: #ff9933; color: white;"
    (click)="goBack()">
    Back
  </button>
}
@if(allRunTimes() && allRunTimes().length > 0)
{
  <div class="d-flex flex-column min-vw-50">

    <mat-form-field appearance="fill">
      <mat-label>Integration Run Time</mat-label>
      <mat-select [(ngModel)]="selectedRunTime">
        @for (r of allRunTimes(); track r) {
          <mat-option [value]="r">
            {{r.importTypeDescription}} - {{r.destinationEndpointName}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="med-wide-text-box">
      <mat-label>Comments</mat-label>
      <input matInput [(ngModel)]="commentInput" name="commentInput"
        id="commentInput" maxlength="150" #identifierComments>
    </mat-form-field>

    <mat-form-field appearance="fill" class="med-wide-text-box">
      <mat-label>Jira Story URL</mat-label>
      <input matInput [(ngModel)]="jiraStoryURLInput" name="jiraStoryURLInput"
        id="jiraStoryURLInput" maxlength="150" #identifierJiraStoryURL>
    </mat-form-field>

    <p><b>Date for LastRunTime to be set to for PushBack:</b></p>
    <app-lt-datetimepicker class="datetime-picker" placeholder="Enter a date and time" format="MM/dd/yyyy hh:mm:ss a"
      [(value)]="pushBackLastRunTimeDateInput">
    </app-lt-datetimepicker>

    <p><b>Date for Integration to start PushBack:</b></p>
    <app-lt-datetimepicker class="datetime-picker" placeholder="Enter a date and time" format="MM/dd/yyyy hh:mm:ss a"
      [(value)]="triggerDateInput">
    </app-lt-datetimepicker>

    @if(selectedPushBack == null)
    {
      <button matButton="outlined"
        [disabled]="savingIntegrationPushBack"
        class="inline mt-2 submit-button"
        (click)="addIntegrationPushBack()">
        Add PushBack
      </button>
    }
    @else
    {
      <button matButton="outlined"
        [disabled]="savingIntegrationPushBack"
        class="inline mt-2 submit-button"
        (click)="updateIntegrationPushBack()">
        Update PushBack
      </button>
    }
  </div>
}
